import { render } from "./AudioButtons.vue?vue&type=template&id=0cf467d5"
import script from "./AudioButtons.vue?vue&type=script&lang=js"
export * from "./AudioButtons.vue?vue&type=script&lang=js"

import exportComponent from "D:\\TEMP\\Website_Corneel\\luisterlive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__